<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Trash Products</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Product Name</th>
                            <th>Bank Name</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(product_master,i) in product_masters.data" :key="product_master.PRODUCT_ID">
                            <td>{{ i+1 }}</td>
                            <td>{{ product_master.Product_Name }}</td>
                            <td> {{ product_master.Bank_Name}} </td>
                            <td>
                                <a href="#" @click="restoreProduct(product_master.PRODUCT_ID)"><i class="fas fa-recycle green"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="product_masters" @pagination-change-page="loadAndSearchTrashProduct" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchTrashProduct(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                search:'',
                product_masters:{}
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchTrashProduct();
            })
            Fire.$on('AfterChangeProduct',()=>{
                this.loadAndSearchTrashProduct();
            });
        },
        mounted(){
            this.loadAndSearchTrashProduct();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            restoreProduct(PRODUCT_ID){
                Swal.fire({
                    title: 'Are you sure Restore It?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, do it!'
                    }).then((result) => {
                        if(result.value){
                            axios.get('restoreProduct/'+PRODUCT_ID).then(()=>{
                                Fire.$emit('AfterChangeProduct');
                                this.toast.$emit('SwalSuccess',"Success !", "Product restore successfully.");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Product Is Already In Use");
                            })
                        }
                    })
            },
            loadAndSearchTrashProduct(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchTrashProduct?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.product_masters = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
